import { ClareDbCollection } from "@app/shared/resources/resource-objectifier";
import { CHDataServiceError, DataServiceError } from "@app/shared/services/data-service-error";

export const enum LoadingState {
    init = "init",
    loading = "loading",
    loaded = "loaded",
    error = "error",
}
export interface ErrorState<T> {
    error: DataServiceError<T> | CHDataServiceError<T>;
}
export type CallState<T> = ErrorState<T> | LoadingState;

export interface ApiResultState<T> {
    result: T | null;
    callState: CallState<T>;
    id?: string;
    error?: any;
}

export interface ClareApiResultState<T> {
    result: T | ClareDbCollection<T> | null;
    callState: CallState<T>;
}

export const initialApiObjectState = <T>(result: T | null = null): ApiResultState<T> => {
    const state: ApiResultState<T> = {
        result,
        callState: LoadingState.init,
    };
    return { ...state }; // Clone value and not just return reference.
};

export interface CHApiResultState<T> extends ApiResultState<T> {
    uuid: string;
    pendingDeletions?: any[];
}

export const initialCHObjectState = <T>(result: T = null, uuid = ""): CHApiResultState<T> => ({
    result,
    uuid,
    callState: LoadingState.init,
    pendingDeletions: [],
});
